"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCollectiveMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="224161" id="heritage-roots" className="dark bg-background text-foreground py-32 px-4 sm:px-6 lg:px-8 flex items-center justify-center relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex items-center justify-center" style={{
      backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/peony_sketch_watermark.png')",
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} />
      
      {}
      <div className="absolute inset-12 border border-primary/20 pointer-events-none before:absolute before:inset-[-2px] before:bg-background after:absolute after:inset-[-2px] after:bg-background before:w-8 after:w-8 before:h-full after:h-full before:left-1/2 before:-translate-x-1/2 after:left-1/2 after:-translate-x-1/2" />

      <div ref={ref} className={`max-w-[700px] mx-auto text-center transition-all duration-1000 ease-out z-10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-sm uppercase tracking-widest font-default text-primary mb-8 sm:mb-10">
          Heritage & Roots
        </h2>
        <p className="text-2xl sm:text-[28px] leading-relaxed sm:leading-loose font-serif text-foreground">
          PETAL is a living legacy where generational{" "}
          <span className="text-primary font-medium italic">horticulture</span>{" "}
          meets modern floral artistry. We cultivate seasonal blooms that capture the{" "}
          <span className="text-primary font-medium italic">soul</span>{" "}
          of our garden, bringing the raw beauty of the earth directly into your most cherished moments.
        </p>
      </div>
    </section>;
}